import React, { Component, useRef } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import {
  Grid,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  Divider,
  MenuItem,
} from "@mui/material";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import Button from "../../../../component/button";
import Input from "../../../../component/inputpm";
import Pagination from "@mui/material/Pagination";
import Tooltip from "@mui/material/Tooltip";
import {
  SearchIcon,
  ClearIcon,
  RefreshIcon,
  EditIconNew,
  OpenItemIcon,
  EndItemIcon,
} from "../../../../component/icons/icons";
import CloseIcon from "@mui/icons-material/Close";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import Loader from "../../../../component/loader";
import classes from "../../component/component.module.css";
import "../../component/specification/productSpecification.css";
import {
  toApi,
  fromApi,
  normalizeDateTime,
} from "../../component/specification/characteristicMapper";
import DraggableResizablePaper from "../../../../component/resizablePaper/resizablePaper";
// import { withStyles } from '@mui/styles';
import { formatNumber } from "../../../../helper/numberFormatter";

class OfferingProductSpecCharacteristicsExistingDialog extends Component {
  constructor(props) {
    super(props);
    //this.enumCache = {};
    this.initialState = {
      showLoading: false,
      productSpecifications: [],
      childData: {},
      expandedNodes: [],

      rowsPerPage: 50,
      page: 1,
      startRecord: 1,
      totalCount: 0,
      specificationSearchString: "",
      selectedSpecificationId: "",
      selectedSpecificationDescription: "",

      productCharacteristics: [],
      rowsPerPageCharacteristics: 50,
      pageCharacteristics: 1,
      startRecordCharacteristics: 1,
      totalCharacteristicsCount: 0,
      characteristicId: "",
      characteristicDescription: "",
      name: "",

      filteredProductCharacteristics: [],

      selectedProductId: "",
      selectedCharacteristics: [],
      errors: {},
      formDataAddSpec: {},
      showProductSpecification: false,
      searchTriggered: false,
      screen: null,
    };

    this.state = { ...this.initialState };
  }

  handleAssignAll = () => {
    this.setState({ showProductSpecification: true });
    if (this.props.onCharacteristicsChange) {
      if (
        this.props.changedCharacteristics &&
        this.props.changedCharacteristics.length > 0
      ) {
        const updatedSelectedCharacteristics =
          this.state.selectedCharacteristics.map((selChar) => {
            if (selChar.action === "update") {
              return selChar;
            }
            const changedChar = this.props.changedCharacteristics.find(
              (ch) => ch.id === selChar.id && ch.specId === selChar.specId,
            );
            if (changedChar) {
              return {
                ...selChar,
                value: changedChar.value,
                format: changedChar.format,
              };
            }
            return selChar;
          });
        this.filterData(updatedSelectedCharacteristics);
      } else {
        this.filterData(this.state.selectedCharacteristics);
      }
    }
    if (this.props.screen && this.props.screen === "checkout") {
    } else {
      this.props.setErrorMessage(
        this.props.t("CHARACTERISTIC_UPDATED_SUCCESSFULLY"),
        true,
      );
    }
    this.props.onClose();
  };

  handleChangeAddSpec = (event, id, specId, rowType, rowFormat) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    const { name, value } = event.target;
    this.setState((prevState) => {
      let updatedErrors = { ...prevState.errors };
      let updatedSelectedCharacteristics = [
        ...prevState.selectedCharacteristics,
      ];

      const existingData = prevState.formDataAddSpec[`${specId}_${id}`] || {};
      //let format = name === 'format' ? value : (existingData.format || '');
      let format =
        name === "format" ? value : existingData.format || rowFormat || "";

      let isValid = true;
      let validatedValue = value;

      if (
        name === "value" &&
        (rowType?.toUpperCase() === "ENUMERATION" ||
          rowType?.toUpperCase() === "ENUM")
      ) {
        isValid = this.validateFormat(value, format);
        if (!isValid) {
          validatedValue = "-";
          updatedErrors[`${specId}_${id}`] =
            `Invalid value. Allowed: ${format.replace(/\|/g, ", ")}`;
        } else {
          delete updatedErrors[`${specId}_${id}`];
        }
      }

      const updatedFormData = {
        ...existingData,
        [name]: validatedValue,
        format: name === "format" ? value : format,
      };

      const updatedCharacteristic = {
        specId,
        id,
        value: updatedFormData.value || "",
        format: updatedFormData.format || "",
        name: updatedFormData.name || "",
        action: "update",
      };

      const key = `${specId}_${id}`;
      const existingIndex = updatedSelectedCharacteristics.findIndex(
        (char) => char.id === id && char.specId === specId,
      );
      //if ((updatedFormData.value || '').trim() && updatedFormData.value !== '-' && isValid) {
      //Allow empty value to store
      if (updatedFormData.value !== "-" && isValid) {
        if (existingIndex !== -1) {
          updatedSelectedCharacteristics[existingIndex] = updatedCharacteristic;
        } else {
          updatedSelectedCharacteristics.push(updatedCharacteristic);
        }
      } else {
        updatedSelectedCharacteristics = updatedSelectedCharacteristics.filter(
          (char) => !(char.id === id && char.specId === specId),
        );
      }

      return {
        formDataAddSpec: {
          ...prevState.formDataAddSpec,
          [key]: updatedFormData,
        },
        selectedCharacteristics: updatedSelectedCharacteristics,
        errors: updatedErrors,
      };
    });
  };

  validateFormat = (value, format) => {
    if (!format || !value || value === "-") return true;

    try {
      const regex = new RegExp(`^(${format})$`, "i");
      return regex.test(value);
    } catch (error) {
      //console.error("Invalid regex format:", format);
      return true; // Allow it if the regex is broken
    }
  };

  filterData = (characteristics) => {
    //console.log('----------------characteristics---------',characteristics);
    if (characteristics != "") {
      /*const filteredData = characteristics.map(({ specId, id, value, format, name }) => ({
                specId: specId,
                id: id,
                value: value ? value : '',
                format: format ? format : '',
                name: name ? name : ''
            }));
            this.props.onCharacteristicsChange(filteredData, this.props.offeringData ? this.props.offeringData : null, this.props.productId);*/
      const filteredData = characteristics
        .filter((c) => c.action === "update") // only include updates
        .map(({ specId, id, value, format, name }) => ({
          specId,
          id,
          value: value || "",
          format: format || "",
          name: name || "",
        }));

      if (filteredData.length > 0) {
        this.props.onCharacteristicsChange(
          filteredData,
          this.props.offeringData ? this.props.offeringData : null,
          this.props.productId,
        );
      }
    } else {
      this.props.onCharacteristicsChange("");
    }
  };

  initializeFromProps = async (props) => {
    this.setState({
      productCharacteristics: [],
      filteredCharacteristics: [],
      totalCharacteristicsCount: 0,
      productSpecifications: {},
      //showLoading: true
    });
    const selectedProductId = props.productId;
    const productSpecifications = props.componentProductCharacteristics || {};
    const changedCharacteristics = props.changedCharacteristics || [];
    const expandedNodes = this.getAllNodeIds(productSpecifications); // Auto-expand logic

    // Auto-select root spec and show its characteristics
    let selectedSpecificationPath = "";
    let productCharacteristics = [];
    let selectedSpecificationDescription = "";
    let formDataAddSpec = {};
    let selectedSpecificationId = "";

    if (productSpecifications && typeof productSpecifications === "object") {
      const rootNode = productSpecifications;
      selectedSpecificationPath = [rootNode.id].join("-");
      selectedSpecificationId = rootNode.id;
      //productCharacteristics = rootNode.productSpecCharacteristic || [];

      productCharacteristics = this.collectAllCharacteristics(rootNode);
      selectedSpecificationDescription =
        rootNode.name || rootNode.description || "";
      if (changedCharacteristics.length > 0) {
        changedCharacteristics.forEach((char) => {
          let cKeyId = `${char.specId}_${char.id}`;
          formDataAddSpec[cKeyId] = {
            value: char.value,
            format: char.format,
            name: char.name,
          };
        });
      } else {
        productCharacteristics.forEach((char) => {
          let uKeyId = `${char.specId}_${char.id}`;
          formDataAddSpec[uKeyId] = {
            value: char.value,
            format: char.format,
            name: char.name,
          };
        });
      }
    }

    this.setState(
      {
        selectedProductId,
        productSpecifications,
        expandedNodes,
        selectedSpecificationPath,
        productCharacteristics,
        selectedSpecificationDescription,
        selectedSpecificationId,
        formDataAddSpec,
        filteredCharacteristics: [],
        selectedCharacteristics: productCharacteristics,
        totalCharacteristicsCount: productCharacteristics.length || 0,
        pageCharacteristics: 1,
        startRecordCharacteristics: 1,
        rowsPerPageCharacteristics: 50,
        searchTriggered: false,
        screen: props.screen || null,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  componentDidUpdate(prevProps) {
    if (prevProps.productId !== this.props.productId) {
      (async () => {
        await this.initializeFromProps(this.props);
      })();
    }
  }
  async componentDidMount() {
    await this.initializeFromProps(this.props);
  }

  getEnumerationList = async (id) => {
    if (this.enumCache[id]) {
      return this.enumCache[id]; // Return cached result
    }
    try {
      const formDataEnum = { id };
      const res = await BusApiCall(
        "POST",
        `${constants.busInternalUrl}/passthru/GET_PRODUCT_FEATURE_TYPE/endpoint`,
        formDataEnum,
      );
      const enums =
        res.data.charEnums.length > 0 ? res.data.charEnums || [] : [];
      this.enumCache[id] = enums; // Cache the result
      return enums;
    } catch (err) {
      if (err.response?.data?.message) {
        this.props.setErrorMessage(err.response.data.message, false);
      } else {
        this.props.setErrorMessage(
          this.props.t("DEFAULT_ERROR_MESSAGE"),
          false,
        );
      }
      console.error("Error fetching Product Characteristics:", err);
      return [];
    }
  };

  getAllNodeIds = (node) => {
    let ids = [node.id];
    if (Array.isArray(node.productSpecificationRelationship)) {
      node.productSpecificationRelationship.forEach((child) => {
        ids = ids.concat(this.getAllNodeIds(child));
      });
    }
    return ids;
  };

  /*handleSpecSelectold = (specNode) => {
        this.setState({
            selectedSpecificationId: specNode.id,
            selectedSpecificationDescription: specNode.description || specNode.name,
            productCharacteristics: specNode.productSpecCharacteristic || [],
            totalCharacteristicsCount: (specNode.productSpecCharacteristic || []).length
        });
    };
    handleSpecSelect = (clickedNode) => {
        const fullNode = this.findNodeById(this.state.productSpecifications, clickedNode.id);

        const pathString = [clickedNode.id].join('-');
        const characteristics = this.collectAllCharacteristics(fullNode);
        const selectedSpecificationDescription = clickedNode.name || clickedNode.description || '';

        this.setState({
            selectedSpecificationPath: pathString,
            productCharacteristics: characteristics,
            selectedSpecificationDescription
        });
    };*/

  collectAllCharacteristics = (node) => {
    let productSpecCharacteristic = [];
    if (Array.isArray(node.productSpecCharacteristic)) {
      productSpecCharacteristic = node.productSpecCharacteristic.map((char) => {
        let enrichedChar = {
          ...char,
          specName: node.name || "",
          specId: node.id || "",
        };

        /* if (char.valueType === 'ENUMERATION') {
                     enrichedChar.values = this.enumCache[char.id] || [];
                 }*/

        return enrichedChar;
      });
    }

    if (Array.isArray(node.productSpecificationRelationship)) {
      for (const child of node.productSpecificationRelationship) {
        productSpecCharacteristic = productSpecCharacteristic.concat(
          this.collectAllCharacteristics(child),
        );
      }
    }
    return productSpecCharacteristic;
  };

  selectCharacteristicDialog = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent dialogHeight"
        handle="#select-characteristic-dialog"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  getCharacteristicList = () => {
    const {
      name,
      characteristicDescription,
      productCharacteristics,
      startRecordCharacteristics,
      rowsPerPageCharacteristics,
    } = this.state;

    let filteredList = productCharacteristics.filter((char) => {
      const nameMatch = name
        ? char.name?.toLowerCase().includes(name.toLowerCase())
        : true;
      const descMatch = characteristicDescription
        ? char.description
            ?.toLowerCase()
            .includes(characteristicDescription.toLowerCase())
        : true;
      return nameMatch && descMatch;
    });

    const totalCount = filteredList.length;

    const paginatedList = filteredList.slice(
      startRecordCharacteristics - 1,
      startRecordCharacteristics - 1 + rowsPerPageCharacteristics,
    );

    this.setState({
      filteredCharacteristics: paginatedList,
      totalCharacteristicsCount: totalCount,
    });
  };

  clearSearchCharacteristic = () => {
    this.setState(
      {
        name: "",
        characteristicDescription: "",
        pageCharacteristics: 1,
        startRecordCharacteristics: 1,
        searchTriggered: false,
      },
      () => {
        this.getCharacteristicList(); // Refresh the list after clearing filters
      },
    );
  };

  onCharacteristicSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.setState(
        {
          searchTriggered: true,
        },
        () => {
          this.getCharacteristicList();
        },
      );
    }
  };

  searchCharacteristics = () => {
    this.setState(
      {
        searchTriggered: true,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  SearchSectionCharacteristic = () => {
    const { t } = this.props;
    return (
      <div
        className={classes.searchOuterDiv}
        style={{ padding: "1rem 0.5rem 0.5rem" }}
      >
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("NAME")}
            value={this.state.name}
            name={"name"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onCharacteristicSearchKeyDown}
          />
        </div>
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("DESCRIPTION")}
            value={this.state.characteristicDescription}
            name={"characteristicDescription"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onCharacteristicSearchKeyDown}
          />
        </div>
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <Tooltip title={t("SEARCH")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.searchCharacteristics}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
          &nbsp;
          <Tooltip title={t("CLEAR")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.clearSearchCharacteristic}
            >
              <ClearIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    );
  };

  PaginationCharacteristic = () => {
    const { t } = this.props;
    return (
      <div
        className="global-custom-pagination"
        style={{ background: "rgba(196, 196, 196, 0.2)" }}
      >
        <label style={{ float: "left", padding: "5px" }}>
          {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalCharacteristicsCount)}
        </label>
        <label>
          {t("ROWS_PER_PAGE")}:
          <Select
            value={this.state.rowsPerPageCharacteristics}
            onChange={this.handleChangeRowsPerPageCharacteristics}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </label>
        <Pagination
          count={Math.ceil(
            this.state.totalCharacteristicsCount /
              this.state.rowsPerPageCharacteristics,
          )}
          onChange={this.handleChangePageCharacteristics}
          page={this.state.pageCharacteristics}
          showFirstButton
          showLastButton
        />
      </div>
    );
  };

  handleChangePageCharacteristics = (event, newPage) => {
    this.setState(
      {
        pageCharacteristics: newPage,
        startRecordCharacteristics:
          this.state.rowsPerPageCharacteristics * (newPage - 1) + 1,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  handleChangeRowsPerPageCharacteristics = (event) => {
    this.setState(
      {
        pageCharacteristics: 1,
        rowsPerPageCharacteristics: event.target.value,
        startRecordCharacteristics: 1,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  renderTreeItems = (nodes, path = []) => {
    return [nodes].flat().map((node) => {
      const currentPath = [...path, node.id];
      const pathString = currentPath.join("-");

      const isSelected = this.state.selectedSpecificationPath === pathString;
      const isExpanded = this.state.expandedNodes.includes(pathString);
      const hasChildren =
        node.productSpecificationRelationship &&
        node.productSpecificationRelationship.length > 0;

      const handleNodeClick = (e) => {
        e.stopPropagation();
        let allCharacteristics = this.collectAllCharacteristics(node);
        this.setState({
          selectedSpecificationPath: pathString,
          selectedSpecificationDescription: node.name || node.description || "",
          productCharacteristics: allCharacteristics,
          totalCharacteristicsCount: allCharacteristics.length,
          selectedSpecificationId: node.id,
          formDataAddSpec: {},
          errors: {},
        });
      };

      const handleToggle = (e) => {
        e.stopPropagation();
        const updated = isExpanded
          ? this.state.expandedNodes.filter((id) => id !== pathString)
          : [...this.state.expandedNodes, pathString];
        this.setState({ expandedNodes: updated });
      };

      return (
        <TreeItem
          key={pathString}
          nodeId={pathString}
          className={isSelected ? "selectedNode" : ""}
          label={
            <div style={{ display: "flex", alignItems: "center" }}>
              {hasChildren ? (
                <>
                  <div
                    className={`expandIconWrapper ${isExpanded ? "isOpen" : ""}`}
                    style={{ paddingRight: "5px", cursor: "pointer" }}
                    onClick={handleToggle}
                  >
                    <OpenItemIcon />
                  </div>
                  <div
                    onClick={(e) => handleNodeClick(e)}
                    style={{ cursor: "pointer" }}
                  >
                    {node.name || node.description}
                  </div>
                </>
              ) : (
                <>
                  <div
                    className={`expandIconWrapper`}
                    style={{ paddingRight: "5px" }}
                  >
                    <EndItemIcon />
                  </div>
                  <div
                    onClick={(e) => handleNodeClick(e)}
                    style={{ cursor: "pointer" }}
                  >
                    {node.name || node.description}
                  </div>
                </>
              )}
            </div>
          }
        >
          {hasChildren &&
            this.renderTreeItems(
              node.productSpecificationRelationship,
              currentPath,
            )}
        </TreeItem>
      );
    });
  };

  TableSectionCharacteristic = () => {
    const { t } = this.props;
    const characteristicsToRender = this.state.searchTriggered
      ? this.state.filteredCharacteristics
      : this.state.productCharacteristics;
    const scMap = new Map(
      this.state.selectedCharacteristics.map((sc) => [
        `${sc.specId}_${sc.id}`,
        sc,
      ]),
    );
    var transformProductCharacteristics = characteristicsToRender.map(fromApi);
    const enrichedCharacteristics = transformProductCharacteristics.map(
      (pc) => {
        const key = `${pc.specId}_${pc.id}`;
        const matched = scMap.get(key);

        return {
          ...pc,
          value: matched?.value || pc.value || "",
          format: matched?.format || pc.format || "",
          name: matched?.name || pc.name || "",
        };
      },
    );
    return (
      <TableContainer>
        <Table
          className={
            this.props.screen && this.props.screen === "order"
              ? classes.tableCharViewSales
              : ""
          }
          aria-label="simple table"
        >
          {this.props.screen && this.props.screen === "checkout" ? null : (
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    width:
                      this.props.screen && this.props.screen === "order"
                        ? "33%"
                        : "25%",
                  }}
                >
                  <b>{t("NAME")}</b>
                </TableCell>
                <TableCell
                  style={{
                    width:
                      this.props.screen && this.props.screen === "order"
                        ? "33%"
                        : "25%",
                  }}
                >
                  <b>{t("DESCRIPTION")}</b>
                </TableCell>
                {this.props.screen && this.props.screen === "order" ? null : (
                  <TableCell style={{ width: "25%" }}>
                    <b>{t("VALIDATION_FORMAT")}</b>
                  </TableCell>
                )}
                <TableCell
                  style={{
                    width:
                      this.props.screen && this.props.screen === "order"
                        ? "33%"
                        : "25%",
                  }}
                >
                  <b>{t("VALUE")}</b>
                </TableCell>
              </TableRow>
            </TableHead>
          )}
          <TableBody
            className={
              this.props.screen && this.props.screen === "order"
                ? classes.tableCharViewSales
                : ""
            }
          >
            {enrichedCharacteristics
              .slice()
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((row, index) => (
                <TableRow key={`${row.specId}_${row.id}` || `row-${index}`}>
                  <TableCell
                    style={
                      this.props.screen && this.props.screen === "checkout"
                        ? { width: "50%" }
                        : {}
                    }
                  >
                    {row.name}
                  </TableCell>
                  {this.props.screen &&
                  this.props.screen === "checkout" ? null : (
                    <TableCell style={{ wordBreak: "break-all" }}>
                      {row.description || ""}
                    </TableCell>
                  )}
                  {(this.props.subScreen && this.props.subScreen === "order") ||
                  (this.props.screen &&
                    this.props.screen === "checkout") ? null : (
                    <TableCell>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 10,
                        }}
                      >
                        <Input
                          size={"small"}
                          variant={"outlined"}
                          placeholder={t("VALIDATION_FORMAT")}
                          name="format"
                          divClass={classes.inputClass}
                          disabled={
                            this.state.screen &&
                            this.state.screen === "checkout"
                          }
                          value={
                            this.state.formDataAddSpec[
                              `${row.specId}_${row.id}`
                            ]?.format ??
                            row.format ??
                            ""
                          }
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) =>
                            this.handleChangeAddSpec(
                              e,
                              row.id,
                              row.specId || "",
                              row?.valueType,
                              row.format || "",
                            )
                          }
                        />
                      </Grid>
                    </TableCell>
                  )}
                  {this.props.subScreen && this.props.subScreen === "order" ? (
                    <TableCell>
                      {this.state.formDataAddSpec?.[`${row.specId}_${row.id}`]
                        ?.value ??
                        row.value ??
                        ""}
                    </TableCell>
                  ) : (
                    <TableCell
                      style={
                        this.props.screen && this.props.screen === "checkout"
                          ? { width: "50%" }
                          : {}
                      }
                    >
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 10,
                        }}
                      >
                        {(row?.valueType?.toUpperCase() === "STRING" ||
                          row?.valueType?.toUpperCase() === "OBJECT") && (
                          <>
                            <Input
                              size={"small"}
                              variant={"outlined"}
                              //placeholder={t('VALUE') + ' *'}
                              // placeholder={t('VALUE')}
                              name="value"
                              divClass={classes.inputClass}
                              error={
                                !!this.state.errors[`${row.specId}_${row.id}`]
                              }
                              value={
                                this.state.formDataAddSpec?.[
                                  `${row.specId}_${row.id}`
                                ]?.value ??
                                row.value ??
                                ""
                              }
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) =>
                                this.handleChangeAddSpec(
                                  e,
                                  row.id,
                                  row.specId || "",
                                  row?.valueType,
                                  row.format || "",
                                )
                              }
                              multiline={true}
                              onBlur={(event) => {
                                const value =
                                  this.state.formDataAddSpec[
                                    `${row.specId}_${row.id}`
                                  ]?.value || "";
                                const format =
                                  this.state.formDataAddSpec[
                                    `${row.specId}_${row.id}`
                                  ]?.format ||
                                  row.format ||
                                  "";
                                if (format && value) {
                                  try {
                                    const regex = new RegExp(format);
                                    if (!regex.test(value)) {
                                      this.setState((prevState) => ({
                                        formDataAddSpec: {
                                          ...prevState.formDataAddSpec,
                                          [`${row.specId}_${row.id}`]: {
                                            ...prevState.formDataAddSpec[
                                              `${row.specId}_${row.id}`
                                            ],
                                            value: "",
                                          },
                                        },
                                        errors: {
                                          ...prevState.errors,
                                          [`${row.specId}_${row.id}`]:
                                            `${t("VALIDATION_FORMAT_MSG")}:- ` +
                                            format,
                                        },
                                      }));
                                    } else {
                                      this.setState((prevState) => ({
                                        errors: {
                                          ...prevState.errors,
                                          [`${row.specId}_${row.id}`]: "",
                                        },
                                      }));
                                    }
                                  } catch (error) {
                                    console.error(
                                      "Invalid regex format:",
                                      format,
                                    );
                                  }
                                }
                              }}
                              fullWidth
                            />
                            {this.state.errors[`${row.specId}_${row.id}`] && (
                              <div style={{ color: "red", fontSize: "12px" }}>
                                {this.state.errors[`${row.specId}_${row.id}`]}
                              </div>
                            )}
                          </>
                        )}

                        {row?.valueType?.toUpperCase() === "NUMBER" && (
                          <>
                            <Input
                              type="text"
                              inputProps={{ pattern: "[0-9]*" }}
                              size={"small"}
                              variant={"outlined"}
                              //placeholder={t('VALUE') + ' *'}
                              // placeholder={t('VALUE')}
                              name="value"
                              divClass={classes.inputClass}
                              error={
                                !!this.state.errors[`${row.specId}_${row.id}`]
                              }
                              value={
                                this.state.formDataAddSpec?.[
                                  `${row.specId}_${row.id}`
                                ]?.value ??
                                row.value ??
                                ""
                              }
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) => {
                                const onlyNumbers = e.target.value.replace(
                                  /[^0-9]/g,
                                  "",
                                );
                                this.handleChangeAddSpec(
                                  {
                                    target: {
                                      name: e.target.name,
                                      value: onlyNumbers,
                                    },
                                  },
                                  row.id,
                                  row.specId || "",
                                  row?.valueType,
                                  row.format || "",
                                );
                              }}
                              onBlur={() => {
                                const value =
                                  this.state.formDataAddSpec[
                                    `${row.specId}_${row.id}`
                                  ]?.value || "";
                                const format =
                                  this.state.formDataAddSpec[
                                    `${row.specId}_${row.id}`
                                  ]?.format ||
                                  row.format ||
                                  "";

                                if (format && value) {
                                  try {
                                    const regex = new RegExp(format);
                                    if (!regex.test(value)) {
                                      this.setState((prevState) => ({
                                        formDataAddSpec: {
                                          ...prevState.formDataAddSpec,
                                          [`${row.specId}_${row.id}`]: {
                                            ...prevState.formDataAddSpec[
                                              `${row.specId}_${row.id}`
                                            ],
                                            value: "",
                                          },
                                        },
                                        errors: {
                                          ...prevState.errors,
                                          [`${row.specId}_${row.id}`]:
                                            `${t("VALIDATION_FORMAT_MSG")}:- ` +
                                            format,
                                        },
                                      }));
                                    } else {
                                      this.setState((prevState) => ({
                                        errors: {
                                          ...prevState.errors,
                                          [`${row.specId}_${row.id}`]: "",
                                        },
                                      }));
                                    }
                                  } catch (error) {
                                    console.error(
                                      "Invalid regex format:",
                                      format,
                                    );
                                  }
                                } else {
                                  this.setState((prevState) => ({
                                    formDataAddSpec: {
                                      ...prevState.formDataAddSpec,
                                      [`${row.specId}_${row.id}`]: {
                                        ...prevState.formDataAddSpec[
                                          `${row.specId}_${row.id}`
                                        ],
                                        value: isNaN(value) ? "" : value,
                                      },
                                    },
                                    errors: {
                                      ...prevState.errors,
                                      [`${row.specId}_${row.id}`]: isNaN(value)
                                        ? "Value must be numeric."
                                        : "",
                                    },
                                  }));
                                }
                              }}
                              fullWidth
                            />
                            {this.state.errors[`${row.specId}_${row.id}`] && (
                              <div style={{ color: "red", fontSize: "12px" }}>
                                {this.state.errors[`${row.specId}_${row.id}`]}
                              </div>
                            )}
                          </>
                        )}

                        {row?.valueType?.toUpperCase() === "DECIMAL" && (
                          <>
                            <Input
                              type="text"
                              size="small"
                              variant="outlined"
                              //placeholder={t('VALUE') + ' *'}
                              // placeholder={t('VALUE')}
                              name="value"
                              divClass={classes.inputClass}
                              error={
                                !!this.state.errors[`${row.specId}_${row.id}`]
                              }
                              value={
                                this.state.formDataAddSpec?.[
                                  `${row.specId}_${row.id}`
                                ]?.value ??
                                row.value ??
                                ""
                              }
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) => {
                                const onlyDecimals = e.target.value.replace(
                                  /[^0-9.]/g,
                                  "",
                                ); // Allow numbers and dots
                                if (/^\d*\.?\d*$/.test(onlyDecimals)) {
                                  // Ensure valid decimal format
                                  this.handleChangeAddSpec(
                                    {
                                      target: {
                                        name: e.target.name,
                                        value: onlyDecimals,
                                      },
                                    },
                                    row.id,
                                    row.specId || "",
                                    row?.valueType,
                                    row.format || "",
                                  );
                                }
                              }}
                              onBlur={() => {
                                const value =
                                  this.state.formDataAddSpec[
                                    `${row.specId}_${row.id}`
                                  ]?.value || "";
                                const format =
                                  this.state.formDataAddSpec[
                                    `${row.specId}_${row.id}`
                                  ]?.format ||
                                  row.format ||
                                  "";
                                if (format && value) {
                                  try {
                                    const regex = new RegExp(format);
                                    if (!regex.test(value)) {
                                      this.setState((prevState) => ({
                                        formDataAddSpec: {
                                          ...prevState.formDataAddSpec,
                                          [`${row.specId}_${row.id}`]: {
                                            ...prevState.formDataAddSpec[
                                              `${row.specId}_${row.id}`
                                            ],
                                            value: "",
                                          },
                                        },
                                        errors: {
                                          ...prevState.errors,
                                          [`${row.specId}_${row.id}`]:
                                            `${t("VALIDATION_FORMAT_MSG")}:- ` +
                                            format,
                                        },
                                      }));
                                    } else {
                                      this.setState((prevState) => ({
                                        errors: {
                                          ...prevState.errors,
                                          [`${row.specId}_${row.id}`]: "",
                                        },
                                      }));
                                    }
                                  } catch (error) {
                                    console.error(
                                      "Invalid regex format:",
                                      format,
                                    );
                                  }
                                } else {
                                  this.setState((prevState) => ({
                                    formDataAddSpec: {
                                      ...prevState.formDataAddSpec,
                                      [`${row.specId}_${row.id}`]: {
                                        ...prevState.formDataAddSpec[
                                          `${row.specId}_${row.id}`
                                        ],
                                        value: isNaN(value) ? "" : value,
                                      },
                                    },
                                    errors: {
                                      ...prevState.errors,
                                      [`${row.specId}_${row.id}`]: isNaN(value)
                                        ? "Value must be numeric."
                                        : "",
                                    },
                                  }));
                                }
                              }}
                              fullWidth
                            />
                            {this.state.errors[`${row.specId}_${row.id}`] && (
                              <div style={{ color: "red", fontSize: "12px" }}>
                                {this.state.errors[`${row.specId}_${row.id}`]}
                              </div>
                            )}
                          </>
                        )}

                        {row?.valueType?.toUpperCase() === "DATE" && (
                          <>
                            <FormControl
                              variant="outlined"
                              size="small"
                              fullWidth
                              error={
                                !!this.state.errors[`${row.specId}_${row.id}`]
                              }
                            >
                              <InputLabel style={{ background: "#fff" }} shrink>
                                DD-MM-YYYY
                              </InputLabel>
                              <Input
                                type="date"
                                //size="small"
                                //variant="outlined"
                                //placeholder="YYYY-MM-DD"
                                //placeholder={t('VALUE') + ' *'}
                                //placeholder={t('VALUE')}
                                name="value"
                                divClass={classes.inputClass}
                                //error={!!this.state.errors[`${row.specId}_${row.id}`]}
                                value={
                                  this.state.formDataAddSpec?.[
                                    `${row.specId}_${row.id}`
                                  ]?.value ??
                                  row.value ??
                                  ""
                                }
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) =>
                                  this.handleChangeAddSpec(
                                    e,
                                    row.id,
                                    row.specId || "",
                                    row?.valueType,
                                    row.format || "",
                                  )
                                }
                                onBlur={(e) => {
                                  const value = e.target.value;
                                  // Validate date format
                                  if (!value) {
                                    this.setState((prevState) => ({
                                      errors: {
                                        ...prevState.errors,
                                        value: "Please enter a valid date.",
                                      },
                                    }));
                                  } else {
                                    this.setState((prevState) => ({
                                      errors: {
                                        ...prevState.errors,
                                        value: "",
                                      },
                                    }));
                                  }
                                }}
                                fullWidth
                              />
                            </FormControl>
                            {this.state.errors[`${row.specId}_${row.id}`] && (
                              <div style={{ color: "red", fontSize: "12px" }}>
                                {this.state.errors[`${row.specId}_${row.id}`]}
                              </div>
                            )}
                          </>
                        )}

                        {row?.valueType?.toUpperCase() === "DATETIME" && (
                          <>
                            <FormControl
                              variant="outlined"
                              size="small"
                              fullWidth
                              error={
                                !!this.state.errors[`${row.specId}_${row.id}`]
                              }
                            >
                              <InputLabel style={{ background: "#fff" }} shrink>
                                DD-MM-YYYY HH:MM
                              </InputLabel>
                              <Input
                                type="datetime-local"
                                //size="small"
                                //variant="outlined"
                                //placeholder="YYYY-MM-DD HH:MM:SS"
                                //placeholder={t('VALUE') + ' *'}
                                //placeholder={t('VALUE')}
                                //error={!!this.state.errors[`${row.specId}_${row.id}`]}
                                name="value"
                                divClass={classes.inputClass}
                                /*value={
                                                                this.state.formDataAddSpec?.[`${row.specId}_${row.id}`]?.value ??
                                                                row.value ?? ''
                                                            }*/
                                value={normalizeDateTime(
                                  this.state.formDataAddSpec?.[
                                    `${row.specId}_${row.id}`
                                  ]?.value ??
                                    row.value ??
                                    "",
                                )}
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) =>
                                  this.handleChangeAddSpec(
                                    e,
                                    row.id,
                                    row.specId || "",
                                    row?.valueType,
                                    row.format || "",
                                  )
                                }
                                onBlur={(e) => {
                                  const value = e.target.value;
                                  // Validate date format
                                  if (!value) {
                                    this.setState((prevState) => ({
                                      errors: {
                                        ...prevState.errors,
                                        value:
                                          "Please enter a valid date and time.",
                                      },
                                    }));
                                  } else {
                                    this.setState((prevState) => ({
                                      errors: {
                                        ...prevState.errors,
                                        value: "",
                                      },
                                    }));
                                  }
                                }}
                              />
                            </FormControl>
                            {this.state.errors[`${row.specId}_${row.id}`] && (
                              <div style={{ color: "red", fontSize: "12px" }}>
                                {this.state.errors[`${row.specId}_${row.id}`]}
                              </div>
                            )}
                          </>
                        )}

                        {(row?.valueType?.toUpperCase() === "ENUMERATION" ||
                          row?.valueType?.toUpperCase() === "ENUM") && (
                          <FormControl
                            variant="outlined"
                            size="small"
                            className={classes.customeSelectLabel}
                            error={
                              !!this.state.errors[`${row.specId}_${row.id}`]
                            }
                            fullWidth
                          >
                            <InputLabel
                              id={`enumSpecLabel_${row.specId}_${row.id}`}
                              style={{ background: "#fff" }}
                              shrink
                            >
                              {t("VALUE")}
                            </InputLabel>
                            <Select
                              size={"small"}
                              variant={"outlined"}
                              name="value"
                              value={
                                this.state.formDataAddSpec?.[
                                  `${row.specId}_${row.id}`
                                ]?.value ??
                                row.value ??
                                ""
                              }
                              native
                              label="VALUE"
                              labelId={`enumSpecLabel_${row.specId}_${row.id}`}
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) =>
                                this.handleChangeAddSpec(
                                  e,
                                  row.id,
                                  row.specId || "",
                                  row?.valueType,
                                  row.format || "",
                                )
                              }
                            >
                              <option value="-">Select</option>
                              {/*{row?.characteristicValueSpecification?.map((option) => (
                                                            <option key={option.id} value={option.value}>
                                                                {option.id} : {option.value}
                                                            </option>
                                                        ))}*/}
                              {(row?.characteristicValueSpecification?.length
                                ? row.characteristicValueSpecification
                                : row?.enumerationValues || []
                              ).map((option) => (
                                <option key={option.id} value={option.value}>
                                  {option.id} : {option.value}
                                </option>
                              ))}
                            </Select>
                            {this.state.errors[`${row.specId}_${row.id}`] && (
                              <FormHelperText>
                                {this.state.errors[`${row.specId}_${row.id}`]}
                              </FormHelperText>
                            )}
                          </FormControl>
                        )}
                        {row?.valueType?.toUpperCase() === "BOOLEAN" && (
                          <FormControl
                            variant="outlined"
                            size="small"
                            className={classes.customeSelectLabel}
                            error={
                              !!this.state.errors[`${row.specId}_${row.id}`]
                            }
                            fullWidth
                          >
                            {/*<InputLabel id={`booleanSpecLabel_${row.specId}_${row.id}`} style={{ background: "#fff" }} shrink>{t('VALUE')}</InputLabel>*/}
                            <Select
                              size={"small"}
                              variant={"outlined"}
                              name="value"
                              value={
                                this.state.formDataAddSpec?.[
                                  `${row.specId}_${row.id}`
                                ]?.value ??
                                row.value ??
                                ""
                              }
                              native
                              //label='VALUE'
                              //labelId={`booleanSpecLabel_${row.specId}_${row.id}`}
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) =>
                                this.handleChangeAddSpec(
                                  e,
                                  row.id,
                                  row.specId || "",
                                  row?.valueType,
                                  row.format || "",
                                )
                              }
                            >
                              <option value="-">Select</option>
                              <option value="true">True</option>
                              <option value="false">False</option>
                            </Select>
                            {this.state.errors[`${row.specId}_${row.id}`] && (
                              <FormHelperText>
                                {this.state.errors[`${row.specId}_${row.id}`]}
                              </FormHelperText>
                            )}
                          </FormControl>
                        )}
                        <span style={{ textTransform: "capitalize" }}>
                          {row?.valueType?.toUpperCase() === "ENUMERATION" ||
                          row?.valueType?.toUpperCase() === "ENUM"
                            ? "(Enum)"
                            : `(` + row?.valueType.toLowerCase() + `)`}
                        </span>
                      </Grid>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            {!this.state.showLoading &&
              enrichedCharacteristics.length === 0 && (
                <TableRow>
                  <TableCell
                    colSpan={3}
                    align="center"
                    style={{ textAlign: "center" }}
                  >
                    {t("NO_CHARACTERISTIC_FOUND")}
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  render() {
    const {
      t,
      open,
      productId,
      productName,
      onClose,
      componentProductCharacteristics,
    } = this.props;
    const { classes: jssClasses } = this.props;
    //this.state.selectedProductId = productId;
    return (
      <React.Fragment>
        {this.props.screen && this.props.screen === "checkout" ? (
          <>
            {this.state.productCharacteristics.length > 0 && (
              <Grid container spacing={0} alignItems="flex-end">
                <Grid
                  item
                  style={{ overflow: "hidden", padding: "10px 10px 0 10px" }}
                  size={{
                    xs: 12,
                    md: 9,
                  }}
                >
                  <>
                    {/* <Typography variant="h6" component="div" style={{ marginBottom: "20px", borderBottom: "1px solid lightgrey", padding: "1rem" }}>
                                        {this.state.selectedSpecificationDescription} {t('PRODUCT_CHARACTERISTIC')}
                                    </Typography> */}
                    <Card
                      variant="outlined"
                      style={{ borderRadius: "8px", border: "none" }}
                    >
                      <div className={classes.root}>
                        {/* {this.SearchSectionCharacteristic()} */}
                        {this.TableSectionCharacteristic()}
                        {/* {this.state.totalCharacteristicsCount > this.state.rowsPerPageCharacteristics && (this.PaginationCharacteristic())} */}
                      </div>
                    </Card>
                  </>
                </Grid>
                <Grid
                  item
                  style={{ padding: "10px 0 0 10px", textAlign: "right" }}
                  size={{
                    xs: 12,
                    md: 3,
                  }}
                >
                  {this.props.subScreen &&
                  this.props.subScreen === "order" ? null : (
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleAssignAll();
                      }}
                      color="primary"
                    >
                      Update
                    </Button>
                  )}
                </Grid>
              </Grid>
            )}
            {!this.state.showLoading &&
              this.state.productCharacteristics.length === 0 && (
                <Grid
                  item
                  style={{
                    overflow: "hidden",
                    padding: "10px 10px 0 10px",
                    textAlign: "center",
                  }}
                  size={{
                    xs: 12,
                  }}
                >
                  {t("NO_CHARACTERISTIC_FOUND")}
                </Grid>
              )}
          </>
        ) : (
          <Dialog
            open={open}
            fullWidth
            maxWidth="lg"
            disableScrollLock={true}
            // PaperComponent={this.selectCharacteristicDialog}
            PaperComponent={DraggableResizablePaper}
            aria-labelledby="select-characteristic-dialog"
            PaperProps={{
              style: {
                height: window.innerHeight > 700 ? "600px" : "90vh", // Set a fixed height
                minHeight: "500px",
                margin: 0, // Optional: Ensures it doesn't shrink too much
              },
              // className: jssClasses.resizablePaper,
            }}
            onClose={(event, reason) => {
              if (reason !== "backdropClick") {
                onClose();
              }
            }}
          >
            <DialogTitle
              id="select-characteristic-dialog"
              style={{ cursor: "move" }}
            >
              <div style={{ display: "flex" }}>
                <span style={{ display: "inline-flex", width: "95%" }}>
                  {productName
                    ? `${t("PRODUCT_SPECIFICATION")} for: ${productName}`
                    : `${t("PRODUCT_SPECIFICATION")}`}
                </span>
                <Tooltip title={t("CLOSE")}>
                  <IconButton
                    onTouchStart={(event) => onClose()}
                    onClick={(event) => onClose()}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
            <DialogContent dividers>
              <div
                style={{
                  borderRadius: "8px",
                  border: "1px solid lightgrey",
                  background: "white",
                  marginBottom: "20px",
                }}
              >
                <Grid container spacing={0}>
                  <>
                    {Object.keys(this.state.productSpecifications).length >
                      0 && (
                      <>
                        <Grid
                          item
                          style={{
                            borderRight: "1px solid lightgrey",
                            padding: "1rem",
                          }}
                          size={{
                            xs: 12,
                            md: 3,
                          }}
                        >
                          <SimpleTreeView
                            className="specificationNodeRoot specificationNodeRootTreeView"
                            expanded={this.state.expandedNodes}
                          >
                            {this.renderTreeItems(
                              this.state.productSpecifications,
                            )}
                          </SimpleTreeView>
                        </Grid>
                        {this.state.productCharacteristics.length > 0 && (
                          <Grid
                            item
                            style={{ overflow: "hidden", padding: "1rem" }}
                            size={{
                              xs: 12,
                              md: 9,
                            }}
                          >
                            <>
                              <Typography
                                variant="h6"
                                component="div"
                                style={{
                                  marginBottom: "20px",
                                  borderBottom: "1px solid lightgrey",
                                  padding: "1rem",
                                }}
                              >
                                {this.state.selectedSpecificationDescription}{" "}
                                {t("PRODUCT_CHARACTERISTIC")}
                              </Typography>
                              <Card
                                variant="outlined"
                                style={{
                                  borderRadius: "8px",
                                  marginBottom: "20px",
                                }}
                              >
                                <div className={classes.root}>
                                  {this.SearchSectionCharacteristic()}
                                  {this.TableSectionCharacteristic()}
                                  {this.state.totalCharacteristicsCount >
                                    this.state.rowsPerPageCharacteristics &&
                                    this.PaginationCharacteristic()}
                                </div>
                              </Card>
                            </>
                          </Grid>
                        )}
                        {!this.state.showLoading &&
                          this.state.productCharacteristics.length === 0 && (
                            <Grid
                              item
                              style={{
                                overflow: "hidden",
                                padding: "1rem",
                                textAlign: "center",
                              }}
                              size={{
                                xs: 12,
                                md: 9,
                              }}
                            >
                              {t("NO_CHARACTERISTIC_FOUND")}
                            </Grid>
                          )}
                      </>
                    )}
                    {!this.state.showLoading &&
                      Object.keys(this.state.productSpecifications).length ===
                        0 && (
                        <Grid
                          item
                          style={{
                            overflow: "hidden",
                            padding: "1rem",
                            textAlign: "center",
                          }}
                          size={{
                            xs: 12,
                          }}
                        >
                          {t("NO_CHARACTERISTIC_FOUND")}
                        </Grid>
                      )}
                  </>
                </Grid>
              </div>
              <Loader loading={this.state.showLoading} />
            </DialogContent>
            {this.props.screen && this.props.screen === "order" ? null : (
              <DialogActions>
                {/*<Button onClick={onClose} color="primary">Cancel</Button> */}
                {Object.keys(this.state.productSpecifications).length > 0 && (
                  <Button onClick={this.handleAssignAll} color="primary">
                    Update
                  </Button>
                )}
              </DialogActions>
            )}
          </Dialog>
        )}
      </React.Fragment>
    );
  }
}

// const styles = {
//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '65vw',
//     },
// };

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    enabledModules: state.auth.enabledModules,
    permissions: state.auth.userPerms,
    tenantData: state.auth.tenantData,
    loggedInUserType: state.auth.userLoginType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withTranslation("translations")(
    OfferingProductSpecCharacteristicsExistingDialog,
  ),
);
